import { Injectable } from '@angular/core';
import { SystemService } from '../system.service';

@Injectable({
  providedIn: 'root'
})
export class LinkedInService {

  constructor(private system: SystemService) { }

  redirectToLinkedIn(jobId: string) {
    const url = `${this.system.webURL}/linkedin?job_id=${jobId}`;
    window.location.href = url;
  }
  
  private generateState(): string {
    return Math.random().toString(36).substring(2); // Simple random string generation
  }  
}
